import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { PDA1060_R01Dto, PDA1060_R01SearchParams } from "../containers/PDA/PDA1060_R01/PDA1060_R01Dto";
import { PDA1061_R01Dto, PDA1061_R01SearchParams } from "../containers/PDA/PDA1061_R01/PDA1061_R01Dto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1060_R01`;
const baseUrlR02 = `${config.apiUrl}/PDA1061_R01`;

// 재고 조회
export const getStockList = async (params?: PDA1060_R01SearchParams) => {
  const url = `${baseUrl}`;
  return await getData<ResponseDto<PDA1060_R01Dto[]>>(url, { params });
};

// 재고 조회 (검색)
export const searchStock = async (params?: PDA1060_R01SearchParams) => {
  const url = `${baseUrl}/search`;
  return await getData<ResponseDto<PDA1060_R01Dto[]>>(url, { params });
};

// 재고 조회 (새로고침)
export const refetchStock = async (params?: PDA1060_R01SearchParams) => {
  const url = `${baseUrl}/refetch`;
  return await getData<ResponseDto<PDA1060_R01Dto[]>>(url, { params });
};

// PDA1061_R01 재고 조회
export const searchStockR02 = async (params?: PDA1061_R01SearchParams) => {
  const url = `${baseUrlR02}/search`;
  return await getData<ResponseDto<PDA1061_R01Dto[]>>(url, { params });
};

export const refetchStockR02 = async (params?: PDA1061_R01SearchParams) => {
  const url = `${baseUrlR02}/refetch`;
  return await getData<ResponseDto<PDA1061_R01Dto[]>>(url, { params });
};

